import * as React from "react";
import { cn } from "../../lib/utils";

export interface FontControlsProps {
	onIncrease?: () => void;
	onDecrease?: () => void;
	onReset?: () => void;
	className?: string;
}

const FontControls: React.FC<FontControlsProps> = ({
	onIncrease,
	onDecrease,
	onReset,
	className,
}) => {
	return (
		<div
			className={cn(
				"flex items-center gap-px rounded-md border border-gray-200 dark:border-white/[0.08] overflow-hidden",
				className,
			)}
		>
			<button
				type="button"
				onClick={onDecrease}
				className="px-1.5 py-1 text-[10px] tabular text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors"
				title="Decrease font size"
			>
				A−
			</button>
			{onReset && (
				<>
					<div className="w-px self-stretch bg-gray-200 dark:bg-white/[0.08]" />
					<button
						type="button"
						onClick={onReset}
						className="px-1.5 py-1 text-[10px] tabular text-gray-500 dark:text-gray-500 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors"
						title="Reset font size"
					>
						↺
					</button>
				</>
			)}
			<div className="w-px self-stretch bg-gray-200 dark:bg-white/[0.08]" />
			<button
				type="button"
				onClick={onIncrease}
				className="px-1.5 py-1 text-[11px] tabular text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-colors"
				title="Increase font size"
			>
				A+
			</button>
		</div>
	);
};
FontControls.displayName = "FontControls";

export { FontControls };
